import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import React, { useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DefaultSectionProps } from 'src/Libs/smart-charge/types'
import ChargePowerSettingsForm from 'src/Libs/smart-charge/components/charge-power/ChargePowerSettingsForm'
import { SmartChargeSettingsFormModel } from 'src/Libs/smart-charge/models'
import { fromSmartChargeModelToFormModel } from 'src/Libs/smart-charge/transformers'
import { makeStyles } from 'tss-react/mui'
import FormikWithExitHandler from 'src/Libs/form/components/FormikWithExitHandler'
import { useAppRatingContext } from 'src/Libs/app-rating/hooks'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props extends DefaultSectionProps {
  hasWritingRights?: boolean
}

const ChargePowerSection: React.FC<Props> = ({ onChange, model, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()

  const [formValues, setFormValues] = useState(model ? fromSmartChargeModelToFormModel(model) : null)
  const { classes } = useStyles()
  const { triggerAppRating } = useAppRatingContext()

  const handleSubmit = async (values: SmartChargeSettingsFormModel): Promise<void> => {
    try {
      await onChange(values)
      triggerAppRating()
    } catch (error) {
      /* revert changes */
      if (formValues) setFormValues({ ...formValues })
    }
  }

  if (!formValues || !model) {
    return (
      <AccordionItem title={t('systemSettings.smartFunctions.smartCharge.chargePower.sectionTitle')}>
        <SystemSettingsBlankView />
      </AccordionItem>
    )
  }

  return (
    <FormikWithExitHandler formKey="charge-power-section-form" initialValues={formValues} onSubmit={handleSubmit}>
      <AccordionItem
        title={t('systemSettings.smartFunctions.smartCharge.chargePower.sectionTitle')}
        contentClassName={classes.contentAccordion}
        headerContentClassName={classes.headerContent}
      >
        <ChargePowerSettingsForm
          isActive={model.emsManualChargeActive}
          max={model.emsSysSpec.maxChargePower}
          min={0}
          hasWritingRights={hasWritingRights}
          lastChargeStartTime={model.emsManualChargeLastStart}
        />
      </AccordionItem>
    </FormikWithExitHandler>
  )
}

export default ChargePowerSection
